const es = {
  'app.name': 'AI Craft Studio',
  'nav.signIn': 'Iniciar sesión',
  'nav.signOut': 'Cerrar sesión',
  'nav.signingIn': 'Iniciando sesión…',
  'nav.loading': 'Cargando…',
  'nav.backToDashboard': 'Volver al panel',
  'nav.back': 'Atrás',
  'nav.language': 'Idioma',

  'credits.label': 'Créditos: {count}',
  'credits.loading': 'Créditos: —',
  'credits.buyMore': 'Comprar créditos',
  'credits.tooltipBuy': 'Haz clic para comprar más créditos',
  'credits.tooltipLoading': 'Cargando tu saldo de créditos',

  'auth.title': 'Inicia sesión para continuar',
  'auth.subtitle': 'Inicia sesión con Google para obtener tus créditos gratuitos y seguir tu uso',
  'auth.google': 'Continuar con Google',
  'auth.signOutFailed': 'No se pudo cerrar la sesión. Inténtalo de nuevo.',
  'auth.signInFailed': 'No se pudo iniciar sesión. Inténtalo de nuevo.',

  'landing.headline': 'Crea la foto que no hiciste.',
  'landing.sub': 'Inicia sesión para empezar. Los tres primeros créditos corren de nuestra cuenta.',
  'landing.note': 'Un crédito por imagen, y solo se cobra cuando la imagen llega.',

  'dash.eyebrow': 'Herramientas',
  'dash.headline': 'Crea la foto que no hiciste.',
  'dash.sub': 'Elige una herramienta. Cada una cuesta un crédito, y solo si funciona.',

  'tool.arrow.name': 'Arrow Vision',
  'tool.arrow.transform': 'Mapa → vista',
  'tool.arrow.desc': 'Coloca una flecha en cualquier punto del mapa y mira qué se ve desde ahí.',
  'tool.person.name': 'Quitar personas',
  'tool.person.transform': 'Gentío → vacío',
  'tool.person.desc': 'Quita a los desconocidos de la foto y quédate con el lugar al que fuiste.',
  'tool.clothing.name': 'Probador virtual',
  'tool.clothing.transform': 'Prenda → tú',
  'tool.clothing.desc': 'Pruébate una prenda antes de decidir si la compras.',

  'upload.title': 'Sube tu imagen',
  'upload.hint': 'Haz clic para elegir una imagen o arrástrala aquí',
  'upload.formats': 'Formatos: JPG, PNG, GIF • Tamaño máximo: 10 MB',
  'upload.person': 'Sube la foto de la persona',
  'upload.clothing': 'Sube la foto de la prenda',
  'upload.selectImage': 'Haz clic para elegir una imagen',
  'upload.formatsShort': 'JPG, PNG — máx. 10 MB',
  'upload.tooLarge': 'La imagen supera los 10 MB. Elige una más pequeña.',
  'upload.notImage': 'Ese archivo no es una imagen. Elige un JPG o un PNG.',

  'action.generate': 'Generar',
  'action.generating': 'Generando…',
  'action.download': 'Descargar',
  'action.share': 'Compartir',
  'action.delete': 'Eliminar',
  'action.cancel': 'Cancelar',
  'action.tryAgain': 'Reintentar',
  'action.uploadCustom': 'Subir la tuya',
  'action.browseLibrary': 'Ver la biblioteca',

  'history.show': 'Ver imágenes recientes ({count})',
  'history.hide': 'Ocultar imágenes recientes',
  'history.empty': 'Aquí no hay nada todavía. Tus imágenes aparecerán aquí.',

  'gen.working': 'Creando tu imagen…',
  'gen.takesTime': 'Normalmente tarda menos de un minuto.',
  'gen.noCredits': 'Te has quedado sin créditos. Compra más para seguir.',
  'gen.failed': 'No ha funcionado. No se te ha cobrado el crédito.',
  'gen.blocked': 'El filtro de seguridad rechazó esa foto. Prueba con otra: no se te ha cobrado el crédito.',

  'pay.title': 'Comprar créditos',
  'pay.subtitle': 'Los créditos no caducan.',
  'pay.creditsLabel': '{count} créditos',
  'pay.saved': 'ahorras {amount}',
  'pay.pay': 'Pagar {amount}',
  'pay.processing': 'Procesando…',
  'pay.success': 'Pago completado. Tus créditos ya están añadidos.',
  'pay.failed': 'El pago no se ha completado. No se te ha cobrado.',
  'pay.completeTitle': 'Pago completado',
  'pay.completeBody': 'Tus créditos se han añadido a tu cuenta.',

  'error.title': 'Algo ha salido mal',
  'error.body': 'La página ha encontrado un error inesperado. Recargar suele bastar.',
  'error.reload': 'Recargar la página',
  'notFound.title': 'Página no encontrada',
  'notFound.body': 'Esa dirección no corresponde a nada del estudio.',
  'notFound.home': 'Ir al panel',

  'footer.privacy': 'Política de privacidad',
};

export default es;
